module.exports = __webpack_public_path__ + "img/file-download-regular.e35a34ac.svg";